const idr = new Intl.NumberFormat("id-ID", {
  style: "currency",
  currency: "IDR",
  maximumFractionDigits: 0,
});

export function formatIdr(amount: number): string {
  return idr.format(amount);
}

export function skuLabel(sku: {
  sku_code: string;
  attributes: unknown;
}): string {
  if (sku.attributes && typeof sku.attributes === "object") {
    const values = Object.values(sku.attributes as Record<string, unknown>)
      .filter((value) => typeof value === "string" && value.length > 0)
      .join(" · ");
    if (values) return values;
  }
  return sku.sku_code;
}

export function publicOrigin(): string {
  if (typeof window !== "undefined") return window.location.origin;
  return "http://127.0.0.1:8080";
}
